import React from 'react';

import {
    Divider,
    Typography,
    SxProps,
    useTheme,
    Theme
} from '@mui/material';

import { resolveThemeColor } from '../../theme';

type PropsType = {
    label: React.ReactNode,
    icon?: React.ReactNode,
    color?: string,
    marginTop?: number,
    marginBottom?: number
    onClick?: () => void,
    sx?: SxProps<Theme>
};

const SectionDivider: React.FC<PropsType> = (props) => {
    const {
        label,
        icon,
        color = 'text.primary',
        marginTop = 4,
        marginBottom = 2,
        onClick,
        sx = {}
    } = props;

    const theme = useTheme();
    const resolvedColor = resolveThemeColor(theme, color);

    return (
        <Divider
            sx={{
                marginTop,
                marginBottom,
                ...sx,
                cursor: onClick ? 'pointer' : 'default'
            }}
            onClick={onClick}
        >
            <Typography
                variant="overline"
                sx={{
                    color: resolvedColor,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    '& svg': {
                        color: resolvedColor,
                    },
                }}
            >
                {icon}
                {label}
            </Typography>
        </Divider>
    );
};

export default SectionDivider;
